export const FRAME_VENEER_CONFIGURATION_MODE = 'frame_veneer';

export const isFrameVeneerConfiguration = configuration => (
  configuration?.configurationMode === FRAME_VENEER_CONFIGURATION_MODE
);

export const hasConfiguredFrame = configuration => (
  !!configuration?.frame?.mode && !!configuration?.frame?.kind
);

export const hasConfiguredVeneer = configuration => {
  const dimensions = configuration?.veneer?.dimensions || {};
  return ['front', 'back', 'left', 'right'].some(side => {
    const {left, right, back, front, length, thickness} = dimensions[side] || {};
    return !!length && !!thickness && (!!left || !!right || !!back || !!front);
  });
};

export const hasConfiguredFrameOrVeneer = configuration => (
  hasConfiguredFrame(configuration) || hasConfiguredVeneer(configuration)
);

export const isEmptyFrameVeneerConfiguration = configuration => (
  isFrameVeneerConfiguration(configuration) &&
  !hasConfiguredFrameOrVeneer(configuration)
);
